import React, { lazy, useEffect, useState } from "react";
import NewBanner from "./components/NewBanner";
import DynamicSeoPage from "../DynamicSeoPage";

const HomeBelowFold = lazy(() => import("./HomeBelowFold"));
const NewHome = () => {
  const [showBelowFold, setShowBelowFold] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    if (isMobile) {
      let timeoutId;

      const onScroll = () => {
        if (window.scrollY > 150) {
          setShowBelowFold(true);
          window.removeEventListener("scroll", onScroll);
          if (timeoutId) clearTimeout(timeoutId);
        }
      };

      window.addEventListener("scroll", onScroll, { passive: true });

      // Fallback so content still appears even if user doesn't scroll
      timeoutId = window.setTimeout(() => {
        setShowBelowFold(true);
        window.removeEventListener("scroll", onScroll);
      }, 1500);

      return () => {
        window.removeEventListener("scroll", onScroll);
        if (timeoutId) clearTimeout(timeoutId);
      };
    }

    const schedule = () => setShowBelowFold(true);

    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(schedule);
    } else {
      // Small delay to ensure hero/LCP render first
      setTimeout(schedule, 600);
    }
  }, []);

  return (
    <div>
      <DynamicSeoPage
        page="home"
        defalut={"365 Luxury Homes - Find your Vacation Holiday in Dubai"}
      />
      <NewBanner />
      {showBelowFold && <HomeBelowFold />}
    </div>
  );
};

export default NewHome;
